import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from '@bugsnag/browser-performance';

if (import.meta.env.PROD) {
    window.Bugsnag = Bugsnag.start({apiKey: '1e37af09e6389d493147fddd9371c378'});
    BugsnagPerformance.start({apiKey: '1e37af09e6389d493147fddd9371c378'});
}
